import React from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

import styles from '../../styles/calendar/Calendar.module.scss';
import {
  CheckmarkIcon,
  ClockIcon,
  FlagFilledIcon,
  HalfCirlcleIcon,
  InfoCircleFilledIcon,
} from '../../services/SvgLibrary';

const FilterOption = ({
  id,
  label,
  checked,
  onChange,
  Icon,
  containerClass,
  checkmarkClass,
  infoContent,
}) => {
  return (
    <>
      <label
        className={`${styles['color-filter-container']} ${containerClass}`}>
        {Icon && (
          <Icon
            width='30px'
            height='20px'
            classNameProp={styles['status-icons']}
          />
        )}
        {label}
        <input type='checkbox' checked={checked} onChange={onChange} />
        <span
          className={`${styles['color-filter-checkmark']} ${checkmarkClass}`}></span>
        <InfoCircleFilledIcon
          classNameProp={styles['filter-popover-user-guide']}
          idProp={id}
        />
      </label>
      {infoContent && (
        <UncontrolledPopover
          fade={false}
          trigger='hover'
          placement='bottom'
          target={id}>
          <PopoverBody>
            <div>
              <b>{label}:</b> {infoContent}
            </div>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </>
  );
};

const OpReqsPopovers = ({
  displayReports,
  setDisplayReports,
  displayMilestones,
  setDisplayMilestones,
  statuses,
  toggleStatus,
}) => {
  const typeOptions = [
    {
      id: 'report',
      label: 'Report',
      checked: displayReports,
      onChange: () => setDisplayReports(!displayReports),
      containerClass: styles['completed'],
      checkmarkClass: styles['completed'],
      infoContent:
        'Reports are usually files mandated often on a periodic basis by local law.',
    },
    {
      id: 'milestone',
      label: 'Milestone',
      checked: displayMilestones,
      onChange: () => setDisplayMilestones(!displayMilestones),
      containerClass: styles['completed'],
      checkmarkClass: styles['completed'],
      infoContent: 'Milestones are one time goals that are to be met.',
    },
  ];

  const progressOptions = [
    {
      id: 'completed',
      label: 'Completed',
      checked: statuses.completed,
      onChange: () => toggleStatus('completed'),
      Icon: CheckmarkIcon,
      containerClass: styles['completed'],
      checkmarkClass: styles['completed'],
      infoContent: 'Milestone completed.',
    },
    {
      id: 'received',
      label: 'Received',
      checked: statuses.received,
      onChange: () => toggleStatus('received'),
      Icon: HalfCirlcleIcon,
      containerClass: styles['received'],
      checkmarkClass: styles['received'],
      infoContent: 'A report has been received for an upcoming due date.',
    },
    {
      id: 'upcoming',
      label: 'Upcoming',
      checked: statuses.upcoming,
      onChange: () => toggleStatus('upcoming'),
      Icon: FlagFilledIcon,
      containerClass: styles['upcoming'],
      checkmarkClass: styles['upcoming'],
      infoContent: 'A report or milestone is due for the upcoming due date.',
    },
    {
      id: 'past-due',
      label: 'Past Due',
      checked: statuses.pastDue,
      onChange: () => toggleStatus('pastDue'),
      Icon: ClockIcon,
      containerClass: styles['past-due'],
      checkmarkClass: styles['past-due'],
      infoContent:
        'A report or milestone was not submitted for a due date in the past.',
    },
  ];

  return (
    <UncontrolledPopover
      innerClassName={styles['popover-container']}
      className={styles['popover-outer-container']}
      trigger='legacy'
      placement='bottom'
      target='PopoverCheckbox'>
      <PopoverBody className={styles['filter-dropdown-wrapper']}>
        <h6 className='dropdown-header pb-0'>Type</h6>
        {typeOptions.map(option => (
          <FilterOption key={option.id} {...option} />
        ))}

        <hr className='dropdown-divider' />

        <h6 className='dropdown-header pb-0'>Progress</h6>
        {progressOptions.map(option => (
          <FilterOption key={option.id} {...option} />
        ))}
      </PopoverBody>
    </UncontrolledPopover>
  );
};

export default OpReqsPopovers;
